import React, { useState, useEffect } from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import { useGetConfigMutation } from "../../../api/services"
import "../assets/style.scss"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Col from "@bappweb/col"
import Link from "@bappweb/link"
import MainForm from "./form"

const LandingHeader = () => {
  const [campaignText, setCampaignText] = useState('')

  const [getConfig] = useGetConfigMutation();
  useEffect(() => {
    getConfig("MaasTasima.CampaignText.Landing.Top")
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setCampaignText(payload.configValue)
        }
      })
  }, [getConfig])

  return (
    <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
      <Block className="landing">
        <Grid type="section">
          <Block className="container">
            <Row>
              <Col xs={12} md={5} lg={5} xl={6}>
                <Block className="page-left">
                  <Block dangerouslySetInnerHTML={{ __html: campaignText }} />
                </Block>
              </Col>
              <Col xs={12} md={7} lg={7} xl={6}>
              <MainForm />
              </Col>
            </Row>
          </Block>
        </Grid>
      </Block>
      <Block className="description-section">
        <Grid type="section">
        <Block className="container">
          <Element type="p">
            {
              "Başvuru formunu doldurmanız durumunda, 444 25 25 Akbank Telefon Şubesi veya seçeceğiniz Akbank şubesi sizinle iletişime geçebilecektir."
            }
          </Element>
          <Element type="br" />
          <Element type="p">
            {"Detaylı bilgi için "}
            <Link className="landing-link" href="https://www.akbank.com/hizmetler/sgk-emekli-maas-odemeleri" text="buraya" inline target="_blank" />
            {" tıklayınız."}
          </Element>
          </Block>
        </Grid>
      </Block>
    </Block>
  )
}

export default LandingHeader
